// Dashboard API service for v0.7.0

import type { DashboardResponse, DashboardTrendsResponse } from '../types';

const API_BASE = import.meta.env.VITE_API_URL || '';

/**
 * Get dashboard statistics
 */
export async function getDashboard(): Promise<DashboardResponse> {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('未登入');
  }

  const response = await fetch(`${API_BASE}/api/admin/dashboard`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: { message: '未知錯誤' } }));
    throw new Error(error.error?.message || '取得統計數據失敗');
  }

  return response.json();
}

/**
 * Get dashboard trends
 */
export async function getDashboardTrends(days: number = 30): Promise<DashboardTrendsResponse> {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('未登入');
  }

  const response = await fetch(`${API_BASE}/api/admin/dashboard/trends?days=${days}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: { message: '未知錯誤' } }));
    throw new Error(error.error?.message || '取得趨勢數據失敗');
  }

  return response.json();
}
